import { render, staticRenderFns } from "./buyPage.vue?vue&type=template&id=2004d99c&scoped=true"
import script from "./buyPage.vue?vue&type=script&lang=js"
export * from "./buyPage.vue?vue&type=script&lang=js"
import style0 from "./buyPage.vue?vue&type=style&index=0&id=2004d99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2004d99c",
  null
  
)

export default component.exports